import "rxjs/add/operator/map";
import {
  Component,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  SimpleChanges,
  EventEmitter,
  Input,
} from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/takeUntil";
import {
  MatDialog,
  MatDialogRef,
  MatPaginator,
  MatSort,
  MatTableDataSource,
  MatChipInputEvent,
  MatAutocompleteSelectedEvent,
} from "@angular/material";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import { fuseAnimations } from "../../../../../../core/animations";
import { ENTER, COMMA, SPACE, TAB } from "@angular/cdk/keycodes";
import * as moment from "moment";

//Local component
import { ToggledListComponent } from "./after-client-accept-list/toggled-list/toggledList.component";
import { ToastComponent } from "../../../common/toast.component";

//popup component
import { printDialogComponent } from "../../printDialog/printDialog.component";
import { FuseConfirmDialogComponent } from "../../../../../../core/components/confirm-dialog/confirm-dialog.component";
import { EmailPopupComponent } from "../email-popup/emailPopup.component";
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";

//Pipe
import { FiveDigitRandomNumberPipe } from "../../../pipesFiles/randomNumber.pipe";
import { FirstLinePipe } from "../../../pipesFiles/firstLine.pipe";

//Service file
import { EcommerceOrdersService } from "../../orders/orders.service";
import { SolutionFormService } from "../solutionForm.service";

//Query file
import {
  ReportReviewQueryService,
  SolutionMasterQueryService,
} from "../../../queryFiles/index";

/** Local file */
import {
  orders,
  spekwoType,
  spekwo,
  toastMsg,
  toolTip,
  apiCalls,
  paginationForCustomTable,
  itemsPerPage,
  checkoutFields,
  displayValues,
  requestedWorkPage,
  solutionEstimateButton,
  parentMenuItemsConfig,
} from "../../../utils/index";

import { CommonOrdersService } from "../../orders/commonOrders.service";
import { PreListPopUpComponent } from "../../orders/order-list/pre-list-pop-up/pre-list-pop-up.component";
import { PreviewSupportingInfoComponent } from "./preview-supporting-info/preview-supporting-info.component";
import { ViewLogsDialogComponent } from "../../../../../../core/components/view-logs/view-logs.component";
import { environment } from "../../../../../../../environments/environment";
import { AuditHistoryService } from "../../../../../../core/services/audit-history.service";

const STATUS_ID_MAPPING = {
  'initiate': 1,
  'work_requested': 4,
  'ready_to_estimate': 2,
  'first_review': 18,
  'second_review': 20,
  'final_review': 19,
  'se_complete': 3,
  'cancel_work_request': 12
};

@Component({
  selector: "spekwo-type",
  templateUrl: "./spekwo.component.html",
  styleUrls: ["./spekwo.component.scss"],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None,
  providers: [FiveDigitRandomNumberPipe, FirstLinePipe],
})
export class SpekwoComponent {
  ordersValues = orders;
  spekwoType = spekwoType;
  spekwoValues = spekwo;
  toastMsg = toastMsg;
  toolTip = toolTip;
  apiCalls = apiCalls;
  checkoutFields = checkoutFields;
  displayValues = displayValues;
  requestedWorkPage = requestedWorkPage;
  allStatus: OrderStatus[];
  approveDynamic: ApproveDynamic = {};
  // cancelRequest :boolean;
  cancelWorkRequest: boolean = true;
  supportingNotesFlag = true;
  finalFullSpekwoRes = [];
  oderTypeSku = spekwo;

  @ViewChild("fileInput") fileInput: ElementRef;
  @ViewChild("paginator") paginator: MatPaginator;
  @ViewChild("fieldPaginator") fieldPaginator: MatPaginator;
  @ViewChild(MatSort) dataSourceSort: MatSort;
  @ViewChild(ToggledListComponent) icReportValue; //Get it from another component

  category: FormControl = new FormControl();

  dataSource: MatTableDataSource<ReviewData>;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  emailConfirmRef: MatDialogRef<ConfirmDialogComponent>;

  progress: number = 0;
  totalJobValue: number = 0;
  currentOrderId: number;
  itemsPerPage: number; //Items per page in paginator
  pageNumber: number; // for which page we are currently in
  page: number = 1;
  dragIndex: number; // for identifying dragIndex based on paginator value

  dueDate: any;

  //Review reports
  itemsPerPageForReports: number; //Items per page in paginator
  pageNumberForReports: number;
  pageForReports: number = 1;
  dragIndexForReports: number;

  forTotalCost: number = 0; // total cost after saving
  beforeTotalCost: number = 0; // total cost before saving

  private _subscriptions: Subscription[] = [];

  private unsubscribe = new Subject<void>();
  filteredOptions: Observable<string[]>;
  searchTerm$ = new Subject<string[]>();

  manualFileName: any = "";
  selectedOrder: any = "";
  specificItem: any = [];
  attachmentId: any;
  dialogRef: any;
  lastReviewId: any;
  currentOrderAttachLink: any;
  subCategory: any;
  subCategoryDetail: any;
  categories: any;
  userRole: any;

  fieldArray: Array<any> = [];
  alterFieldArray: Array<any> = [];
  allCategories = [];
  tempCategories = [];

  cost = [];
  combineCategories: any[] = [];
  allReviewReports: any[] = [];
  allReviewReports1: any[] = [];
  allCategoryPopulated = [];
  ocrDocumentUrl: any;
  subjectPropertyAddress: string;

  description = "";
  materialCost = "";
  laborCost = "";
  totalCost = "";
  catagoryType = "";
  solType = "";
  solSheetName = "";
  imageSrc = "";
  solution = "";

  node: string;
  orderStatuses: string;
  insReportId: string;
  solEmail: string;
  orderEmail: string;
  pdfFromCheckout: string;

  orderDetailSpinner: boolean = false; /**Spinner */
  isProcessLoading: boolean = false; /**Spinner */
  bodySpinner: boolean = false; /**Spinner */
  bottomResultSpinner: boolean = false; /**Spinner */

  enableSave: boolean = false;
  enableApproved: boolean = false;
  isClientProcesed: boolean = false;
  isOrderHasAttachment: boolean = false;
  isProcess: boolean;
  isDataLoad: boolean = false;
  showDragSave: boolean = false;
  solutionEstimateEmails = [];
  displayedColumns = [
    "name",
    "description",
    "solution",
    "totalcost",
    "imageSrc",
    "buttons",
  ];
  fieldDisplayedColumns = [
    "category",
    "categorySolution",
    "solution",
    "solutionDesc",
    "totalCost",
    "imgSrc",
  ];
  // Pagination
  pagination = paginationForCustomTable;
  initalLoad = itemsPerPage; //Initial data load per page

  // Pagination
  paginationForReports = paginationForCustomTable;
  initalLoadForReports = itemsPerPage; //Initial data load per page

  selectedIndex: number = 0; //To find drag index to highlight row
  selectedId: string = ""; //To find drag index to highlight row(review reports)

  // Search keyword
  searchKeyWordsList = []; // Serached input
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA, SPACE, TAB];
  @ViewChild("keywordInput") keywordInput: ElementRef;
  matchedResult = []; // Return matched result
  isSDLoad: boolean = false;

  selectedCostOption: string = "";
  tmCostOption: string[] = ["tm", "Flat", "foot"];
  costOptionType = "create";
  selectedTableIndex: number;
  selectedKeywordId: number;
  addtoDbLoader: boolean = false;

  formPlaceHolderValue: string;

  productType: string;
  itemsNumber: any;
  itemsAndDescriptions: any;
  data: any;
  picturesDetails: any;

  allPDFsList: any;
  solutionEstimateButton = solutionEstimateButton;
  public userId: any;
  public roleId: any;

  // Role-based permission properties - Only for approve functionality
  isHighLevelPermission: boolean;
  isProgressingUser: boolean;
  canApproveToClient: boolean; // Only for approval permission
  canSubmitReview: boolean; // For review submission permission
  canAlterSolution: boolean; // For altering solutions

  filterSolEstMenu = [];
  viewBoolean: boolean;
  selectedViewType = "";

  constructor(
    private dialog: MatDialog,
    private location: Location,
    private route: ActivatedRoute,

    /** Local component */
    private toastComponent: ToastComponent,

    /**Service file */
    private allordersService: EcommerceOrdersService,
    private formService: SolutionFormService,
    public commonOrdersService: CommonOrdersService,
    private reportReviewQueryService: ReportReviewQueryService,
    private solutionFormService: SolutionFormService,
    public auditHistoryService: AuditHistoryService,

    public solutionMasterQueryService: SolutionMasterQueryService,

    private router: Router,

  ) {
    this.viewBoolean = router.url.includes("view");
    // get current order from params
    this.route.params.subscribe((params) => {
      this.currentOrderId = Number.parseInt(params.id);
    });

    this.allCategories = this.combineCategories;

    this.userRole = window.localStorage.getItem("role");
    this.userId = window.localStorage.getItem('userUID');
    this.roleId = window.localStorage.getItem('roleId');

    // Set user permissions based on role
    this.setUserPermissions();

    this.getCurrentOrderByOrderId();
  }


  private setUserPermissions(): void {
    // Grant high-level permissions to Account Owner, Executive and Senior Quoter
    this.isHighLevelPermission =
      environment.ownerRoleId === this.roleId ||
      environment.executiveRoleId === this.roleId ||
      environment.seniorQuoterRoleId === this.roleId;

    // ONLY restrict "Approve to client" to Account Owner, Senior quoter and Executive
    this.canApproveToClient =
      environment.ownerRoleId === this.roleId ||
      environment.executiveRoleId === this.roleId ||
      environment.seniorQuoterRoleId === this.roleId;

    // Grant solution alteration rights to Account Owner, Executive and Senior Quoter only
    this.canAlterSolution =
      environment.ownerRoleId === this.roleId ||
      environment.executiveRoleId === this.roleId ||
      environment.seniorQuoterRoleId === this.roleId;

    // Grant review submission rights to ALL roles (same as Account Owner & Executive)
    this.canSubmitReview = true;
  }

  canPerformAction(action: 'approve' | 'submit' | 'general' | 'alter'): boolean {
    switch (action) {
      case 'approve':
        // ONLY Account Owner and Executive can approve to client
        return this.canApproveToClient;
      case 'alter':
        // Only Account Owner, Executive and Senior Quoter can alter solutions
        return this.canAlterSolution;
      case 'submit':
      case 'general':
        // All other actions allowed for Account Owner, Executive and Senior Quoter
        return this.isHighLevelPermission;
      default:
        return true;
    }
  }

  private checkPermissionWithMessage(action: 'approve' | 'submit' | 'alter', actionName: string): boolean {
    if (action === 'approve' && !this.canPerformAction('approve')) {
      let message = `Only Account Owner and Executive can ${actionName}. Your current role: ${this.userRole}`;
      this.toastComponent.showToast(message);
      return false;
    }
    // All other actions are allowed for all roles
    return true;
  }

  ngOnInit() {
    this.commonOrdersService.listOfStatus.subscribe((statusRes) => {

      this.allStatus = statusRes.length > 0 ? statusRes : [];

      const requiredStatuses = ['initiate', 'ready_to_estimate', 'first_review', 'second_review', 'final_review', 'se_complete'];
      const missingStatuses = requiredStatuses.filter(required =>
        !this.allStatus.some(status => status.statusName === required)
      );
    });
    // this.getCurrentOrderByOrderId();

    this.forTotalCost = 0; // total cost after saving
    this.beforeTotalCost = 0; // total cost before saving
    this.cost = [];

    this.pageNumber = 1; // initially set to 1st page
    this.itemsPerPage = this.initalLoad; // initally set to initial value
    this.dragIndex = 0; //initially set to 0

    this.itemsPerPageForReports = this.initalLoadForReports;
    this.pageNumberForReports = 1;
    this.dragIndexForReports = 0;

    //2.Check this report submitted by clieent
    this.checkOrderStatus();

    //3.all review Details from stored details
    this.getAllStoredReports();

    this._subscriptions.push(
      this.formService.currentOrderChanged.subscribe((order) => {
        this.orderDetailSpinner = true;
        if (order) {
          //1.get current order status
          this.getOrder(order);
        }
      })
    );
    this._subscriptions.push(
      this.formService.ocrDocumentChange.subscribe((res) => {
        if (!res.loading) {
          this.ocrDocumentUrl = res.data;
        }
      })
    );

    //get subjectProperty address.
    this._subscriptions.push(
      this.formService.buyerPropertyChanges.subscribe((data) => {
        this.subjectPropertyAddress = data;
      })
    );
    //get Inspection report  id.
    this._subscriptions.push(
      this.formService.insReportIdChange.subscribe((data) => {
        this.insReportId = data && data.insReportId;
      })
    );

    //Solution estiamtion email.
    this._subscriptions.push(
      this.formService.solutionEmailChanges.subscribe((data) => {
        this.solEmail = data ? data : "";
        // console.log('solutionEmailChanges', this.UTCsecondsPipe.transform());
      })
    );

    //Pdf file link for new order.
    this._subscriptions.push(
      this.formService.pdfLinkFromCheckout.subscribe((checkRes) => {
        if (!checkRes.loading) {
          // console.log('this.pdfFromCheckout', checkRes)
          var attachmentId = this.currentOrderId - 1;
          this.allordersService.getAttachmentdata1(
            attachmentId,
            this.currentOrderId,
            checkRes.data
          );
        }
      })
    );

    //Pdf final file link.
    this._subscriptions.push(
      this.allordersService.currentOrderPdfFinalLink.subscribe((res) => {
        if (!res.loading) {
          this.isOrderHasAttachment = res.data.isOrderHasAttachment;
          this.currentOrderAttachLink = res.data.currentOrderAttachLink;
        } else {
          this.isOrderHasAttachment = false;
          this.currentOrderAttachLink = "";
        }
      })
    );
  }
  onValueChanged(value) {
    // value will be the emitted value by the child

    this.forTotalCost = value;
  }

  //set all the PDFs
  setAllTheAvailablePDFs() {
    let dataJson = this.data;

    if (dataJson && dataJson.meta_data && dataJson.meta_data.length > 0) {

      // home inspection
      let checkHomeInspection = dataJson.meta_data.filter((data) => {
        return data.key === this.checkoutFields.homeInspectionReport;
      });
      let homeInspectionUrl =
        checkHomeInspection && checkHomeInspection.length > 0 && checkHomeInspection[0].value
          ? checkHomeInspection[0].value
          : null;

      // ddra
      let checkDdra = dataJson.meta_data.filter((data) => {
        return data.key === this.checkoutFields.ddra;
      });
      let ddraUrl =
        checkDdra && checkDdra.length > 0 && checkDdra[0].value
          ? checkDdra[0].value
          : null;

      // uniqueReport
      let checkUniqueReport = dataJson.meta_data.filter((data) => {
        return data.key === this.checkoutFields.uniqueReport;
      });
      let uniqueReportUrl =
        checkUniqueReport && checkUniqueReport.length > 0 && checkUniqueReport[0].value
          ? checkUniqueReport[0].value
          : null;

      // supportReport
      let checkSupportReport = dataJson.meta_data.filter((data) => {
        return data.key === this.checkoutFields.supportReport;
      });
      let checkSupportingReport = dataJson.meta_data.filter((data) => {
        return data.key === this.checkoutFields.supportingReport;
      });
      let supportReportUrl =
        checkSupportReport && checkSupportReport.length > 0 && checkSupportReport[0].value
          ? checkSupportReport[0].value
          : (checkSupportingReport && checkSupportingReport.length > 0 && checkSupportingReport[0].value
            ? checkSupportingReport[0].value
            : null);

      // wdoReport
      let checkWdoReport = dataJson.meta_data.filter((data) => {
        return data.key === this.checkoutFields.wdoReport;
      });
      let wdoReportUrl =
        checkWdoReport && checkWdoReport.length > 0 && checkWdoReport[0].value
          ? checkWdoReport[0].value
          : null;

      // structEngReport
      let checkstructEngReport = dataJson.meta_data.filter((data) => {
        return data.key === this.checkoutFields.structEngReport;
      });
      let structEngReportUrl =
        checkstructEngReport && checkstructEngReport.length > 0 && checkstructEngReport[0].value
          ? checkstructEngReport[0].value
          : null;

      // wdoReport
      let checkWellReport = dataJson.meta_data.filter((data) => {
        return data.key === this.checkoutFields.wellReport;
      });
      let wellReportUrl =
        checkWellReport && checkWellReport.length > 0 && checkWellReport[0].value
          ? checkWellReport[0].value
          : null;

      this.allPDFsList = {
        "homeInspectionUrl": homeInspectionUrl,
        "ddraUrl": ddraUrl,
        "uniqueReportUrl": uniqueReportUrl,
        "supportReportUrl": supportReportUrl,
        "wdoReportUrl": wdoReportUrl,
        "structEngReportUrl": structEngReportUrl,
        "wellReportUrl": wellReportUrl
      }

    }
  }

  getCurrentOrderByOrderId() {
    this.commonOrdersService
      .getOrderByOrderIdFun(this.currentOrderId, this.userId, this.roleId)
      .then(async (response: any) => {
        let responseData = response &&
          response.data &&
          response.data.allOrders &&
          response.data.allOrders.nodes.length > 0 &&
          response.data.allOrders.nodes[0]
          ? response.data.allOrders.nodes[0]
          : {};

        if (responseData.productByProductId.sku == this.oderTypeSku.prouct5 && responseData.contactDate == null && responseData.contactEmail == "" && responseData.contactName == "" && responseData.contactPhone == "" && responseData.projectInfo == "") {
          this.supportingNotesFlag = false
        }
        let data =
          response &&
            response.data &&
            response.data.allOrders &&
            response.data.allOrders.nodes.length > 0 &&
            response.data.allOrders.nodes[0] &&
            response.data.allOrders.nodes[0].orderContent
            ? response.data.allOrders.nodes[0].orderContent
            : null;

        if (data) {
          let orderContent = JSON.parse(data);
          this.data = orderContent ? orderContent : "";
          this.setAllTheAvailablePDFs();

          if (orderContent && orderContent.meta_data && orderContent.meta_data.length > 0) {
            let items = orderContent.meta_data.filter((data) => {
              return data.key === this.checkoutFields.itemList;
            });
            this.itemsNumber = items && items.length > 0 && items[0].value ? items[0].value : "";

            let itemsAndDescriptionsList = orderContent.meta_data.filter((data) => {
              return data.key === this.checkoutFields.fullSpekwoItems;
            });
            this.itemsAndDescriptions = itemsAndDescriptionsList && itemsAndDescriptionsList.length > 0 && itemsAndDescriptionsList[0].value ? itemsAndDescriptionsList[0].value : "";
            let localItemsArray = this.itemsAndDescriptions ? JSON.parse(this.itemsAndDescriptions) : [];
            this.setFullSpekwoDataFormat(localItemsArray);

            if (responseData.productByProductId.sku == this.oderTypeSku.prouct1 && this.finalFullSpekwoRes.length == 0) {
              this.supportingNotesFlag = false
            }

            let checkPreList = orderContent.meta_data.filter((data) => {
              return data.key === this.checkoutFields.preListPicture;
            });

            if (checkPreList && checkPreList.length > 0 && checkPreList[0].value) {
              let value = checkPreList[0].value ? checkPreList[0].value : null;
              if (value) {
                try {
                  this.picturesDetails = JSON.parse(value);
                  if (typeof this.picturesDetails == "object") {
                    this.picturesDetails = this.picturesDetails;
                  } else {
                    this.picturesDetails = JSON.parse(this.picturesDetails.toString());
                  }
                } catch (err) {
                  console.log(err);
                }
              }
            }
          }
        }

        let statusId = responseData && responseData.statusId ? responseData.statusId : null;
        let orderClaimdData = responseData && responseData.claimOrdersByOrderId && responseData.claimOrdersByOrderId.nodes && responseData.claimOrdersByOrderId.nodes.length > 0 ? responseData.claimOrdersByOrderId.nodes : [];
        let formatOrderClaimData = await this.formatClaimOrder(orderClaimdData);
        let filterClaimOrder = await this.claimDataFilter(statusId, formatOrderClaimData);
        let progressUserId = filterClaimOrder.length > 0 && filterClaimOrder[0] && filterClaimOrder[0].userId ? filterClaimOrder[0].userId : null;
        this.isProgressingUser = true;
      })
      .catch((err) => {
        console.log("err", err);
      });
    return this.data;
  }

  async formatClaimOrder(orderClaimdData) {
    let formatClaimOrder = [];
    for (let i = 0; i < orderClaimdData.length; i++) {
      let formatData = {
        roleName: orderClaimdData[i] && orderClaimdData[i].roleByRoleId && orderClaimdData[i].roleByRoleId.roleName ? orderClaimdData[i].roleByRoleId.roleName : null,
        userFirstName: orderClaimdData[i] && orderClaimdData[i].userByUserId && orderClaimdData[i].userByUserId.firstName ? orderClaimdData[i].userByUserId.firstName : null,
        userLastName: orderClaimdData[i] && orderClaimdData[i].userByUserId && orderClaimdData[i].userByUserId.lastName ? orderClaimdData[i].userByUserId.lastName : null,
        statusId: orderClaimdData[i] && orderClaimdData[i].statusId ? orderClaimdData[i].statusId : null,
        userId: orderClaimdData[i] && orderClaimdData[i].userId ? orderClaimdData[i].userId : null,
        claimOrderId: orderClaimdData[i] && orderClaimdData[i].claimOrderId ? orderClaimdData[i].claimOrderId : null,
      };
      formatClaimOrder.push(formatData);
    }
    return formatClaimOrder;
  }

  claimDataFilter(statusId, orderClaimdData) {
    return orderClaimdData.filter((claim) => {
      return claim.statusId === statusId;
    })
  }

  //Getting ViewChild value
  ngAfterContentInit() {
    if (this.userRole != "Owner" || this.isClientProcesed) {
      if (
        this.icReportValue !== undefined &&
        this.icReportValue.hasOwnProperty("totalJobValue")
      ) {
        this.totalJobValue = this.icReportValue.totalJobValue;
      }
    }

    this.commonOrdersService.allMenuItems.subscribe((menuItems) => {
      this.filterSolEstMenu = menuItems.menuItemsList.filter((menuItem) => {
        return menuItem.parentMenuItem === parentMenuItemsConfig.seAuditLog;
      });
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();

    this._subscriptions.forEach((subscriptions) => subscriptions.unsubscribe());
  }

  //Getting pdf file and upload
  onFileChange(event) {
    //Without base64 content using formData
    let element = event.target;
    if (element.files.length > 0) {
      this.manualFileName = {
        filename: element.files[0].name,
        filetype: element.files[0].type,
        file: element.files[0],
      };
    }
  }

  //Stroing pdf file to DB and getting URL link
  onSubmitFile() {
    this.isProcessLoading = true;

    this.formService
      .fileUpload(this.manualFileName.file, this.currentOrderId)
      .then((res: any) => {
        this.isProcessLoading = false;
        // Once submitted document get file url
        this.formService.GetOcrDocument(this.currentOrderId);

        if (res.status == "completed") {
          this.isProcess = true;
          this.toastComponent.showToast(this.toastMsg.processSuccess);
        } else {
          this.isProcess = false;
          this.toastComponent.showToast(this.toastMsg.processFailed);
        }
      })
      .catch(() => {
        this.isProcessLoading = false;
      });
  }

  //Clear selected pdf file
  clearFile() {
    this.fileInput.nativeElement.value = "";
    this.manualFileName = "";
  }
  hoursBasedCost(productCost, discountAmount, paidAmount, createdDate) {
    let dueDate;
    if (productCost == discountAmount + paidAmount) {
      dueDate = moment(new Date(createdDate)).add(72, "hours").format("MM/DD/YYYY");
    } else if (productCost + 20 == discountAmount + paidAmount) {
      dueDate = moment(new Date(createdDate)).add(48, "hours").format("MM/DD/YYYY");
    } else if (productCost + 40 == discountAmount + paidAmount) {
      dueDate = moment(new Date(createdDate)).add(24, "hours").format("MM/DD/YYYY");
    }
    return dueDate;
  }

  calcDueDate(deliveryTime, createdDate) {
    let dueDate;

    if (deliveryTime.value.includes('72 hours')) {
      dueDate = moment(new Date(createdDate))
        .add(72, 'hours')
        .format('MM/DD/YYYY');
    }

    else if (deliveryTime.value.includes('48 hours')) {
      dueDate = moment(new Date(createdDate))
        .add(48, 'hours')
        .format('MM/DD/YYYY');
    }

    else if (deliveryTime.value.includes('24 hours')) {
      dueDate = moment(new Date(createdDate))
        .add(24, 'hours')
        .format('MM/DD/YYYY');
    }
    return dueDate;
  }
  // 1.Subscribe to update order on changes -get current order details

  getOrder(order: any) {
    this.orderDetailSpinner = true;
    var localvar: any;
    var count = 0;
    this.orderEmail = "";
    this.selectedOrder = order;
    if (this.selectedOrder.latitude && this.selectedOrder.longitude) {
      this.selectedOrder.date_created = this.convertUtcToEst(this.selectedOrder.date_created);
    }
    this.specificItem = [];

    var product =
      order.line_items && order.line_items.length > 0
        ? this.spekwoValues[order.line_items[0].sku]
        : "";

    this.productType = product;

    let couponData = order && order.couponByCouponId ? order.couponByCouponId : {};
    let productData = order && order.productByProductId ? order.productByProductId : {};


    if (!product) {
      product = productData && productData.sku ? productData.sku : "";
    }

    let productAmount = productData && productData.productPrice ? productData.productPrice : 0.00;
    var deliveryTime =
      order.line_items && order.line_items.length > 0
        ? _.find(order.line_items[0].meta_data, {
          key: this.checkoutFields.deliveryTime,
        })
        : null;
    // var dueDate;
    if (
      product == this.spekwoValues.HIQFULL ||
      product == this.spekwoValues.CGPYWCK ||
      product == this.spekwoValues.RJCZPSJ
    ) {
      var check =
        order.line_items && order.line_items.length > 0
          ? _.find(order.line_items[0].meta_data, {
            key: this.checkoutFields.deliveryTime,
          })
          : null;
      let paiAmount = order && order.total ? order.total : 0.0;
      let discount =
        order && order.coupon_lines.length > 0 && order.coupon_lines[0].discount
          ? order.coupon_lines[0].discount
          : 0.0;
      if (discount === 0 || discount === 0.00) {
        discount = couponData && couponData.couponAmount ? couponData.couponAmount : 0.00;
      }
      if (product == this.spekwoValues.HIQFULL) {
        this.dueDate = this.calcDueDate(
          deliveryTime,
          order.date_created
        );
      } else if (
        product == this.spekwoValues.CGPYWCK ||
        product == this.spekwoValues.RJCZPSJ
      ) {
        this.dueDate = this.calcDueDate(
          deliveryTime,
          order.date_created
        );
      }
    } else if (
      product == this.spekwoValues.INSPECTIONCALL ||
      product == this.spekwoValues.GCCONSULTING
    ) {
      var check = _.find(order.meta_data, {
        key: this.checkoutFields.apptDate,
      });

      this.dueDate = check
        ? moment(moment(check.value, "DD/MM/YYYY").toDate()).format("MM/DD/YYYY")
        : "";
    }

    _.each(order.line_items, (data: any) => {
      localvar = data.meta_data;

      _.each(localvar, (vari: any) => {
        ++count;
        if (
          vari.key == "1-20 Items" ||
          vari.key == "21-40 Items" ||
          vari.key == "41-60 Items"
        ) {
          this.specificItem.push(vari.value);
        }
      });
      if (localvar.length == count) {
        this.specificItem.sort(function (a: any, b: any) {
          return a - b;
        });
      }
    });

    if (order) {
      this.orderEmail = order.billing && order.billing.email;
      // console.log('order.billing.email', order.billing.email);
    }

    this.orderDetailSpinner = false;
    let filterSolBtnInfo = this.solutionEstimateButton.filter((SolBtnInfo) => {
      return SolBtnInfo.respectiveStatus === this.selectedOrder.status_unique_name
    });
    this.approveDynamic = filterSolBtnInfo.length > 0 ? filterSolBtnInfo[0] : {};
  }

  //Opens home inspection
  openFile() {
    if (this.isOrderHasAttachment) {
      window.open(this.currentOrderAttachLink, "_blank");
    } else if (this.ocrDocumentUrl && this.ocrDocumentUrl.message.length > 0) {
      var url =
        this.apiCalls.ocrDocumentUrl +
        "/" +
        this.currentOrderId +
        "/" +
        this.ocrDocumentUrl.message[0];
      window.open(url, "_blank");
    } else if (
      !this.isOrderHasAttachment &&
      !(this.ocrDocumentUrl && this.ocrDocumentUrl.message.length > 0)
    ) {
      let dataJson = this.getCurrentOrderByOrderId();

      if (dataJson.meta_data && dataJson.meta_data.length > 0) {
        let checkHomeInspection = dataJson.meta_data.filter((data) => {
          return data.key === this.checkoutFields.homeInspectionReport;
        });

        let url =
          checkHomeInspection &&
            checkHomeInspection.length > 0 &&
            checkHomeInspection[0].value
            ? checkHomeInspection[0].value
            : null;

        if (url) {
          window.open(url, "_blank");
        } else {
          this.toastComponent.showToast(this.toastMsg.noDocumentUploaded);
        }
      } else {
        this.toastComponent.showToast(this.toastMsg.noDocumentUploaded);
      }
    } else {
      this.toastComponent.showToast(this.toastMsg.openHomeInspectionFailed);
    }
  }

  //view files
  openFiles(url) {
    if (url) {
      window.open(url, "_blank");
    } else {
      this.toastComponent.showToast(this.toastMsg.noDocumentUploaded);
    }
  }

  //Opens Pre List Pictures
  openFilePreList() {
    this.dialog.open(PreListPopUpComponent, {
      data: {
        orderId: this.currentOrderId,
        insReportId: this.insReportId,
      },
      width: "100%",
      height: "85%",
    });
  }

  // Check current order status
  checkOrderStatus() {
    this.isDataLoad = true;
    this.formService.checkOrderStatus(this.currentOrderId).then((data: any) => {
      if (data && data.length > 0) {
        this.isClientProcesed = true; // try with isDataLoad variable
        this.isDataLoad = false;
        var statusId = data[0] && data[0].node && data[0].node.statusId;
      } else {
        this.isDataLoad = false;
      }

      if (this.isClientProcesed) {
        this.cancelWorkRequest = statusId == 12 ? true : false;
      }
    });
  }

  // Get all stored report
  getAllStoredReports() {
    this.forTotalCost = 0;
    this.bottomResultSpinner = true;
    // console.log('called');
    this._subscriptions.push(
      this.reportReviewQueryService
        .GET_All_STORED_REPORTS(this.currentOrderId)
        .takeUntil(this.unsubscribe)
        .subscribe(
          (response: any) => {
            this.allReviewReports = [];
            this.allReviewReports1 = [];
            if (
              response &&
              response.data &&
              response.data.allReportReviewDetails &&
              response.data.allReportReviewDetails.edges.length > 0
            ) {
              //If already saved, hide 'save' button
              this.enableSave = false;

              response.data.allReportReviewDetails.edges.forEach(
                (review: any) => {
                  //Enabled approved if anything yet to be  approved
                  this.enableApproved =
                    review.node.approve == "yes" ? false : true;
                  var assignedObject = {
                    name: review.node.subCategoryName
                      ? review.node.categoryName
                        ? review.node.categoryName +
                        ":" +
                        review.node.subCategoryName
                        : review.node.subCategoryName
                      : review.node.categoryName, //from input
                    categoryId: review.node.categoryId,
                    subCategoryId: review.node.subCategoryId,
                    reviewId: review.node.reviewId,
                    id: review.node.id,
                    description: review.node.description,
                    totalCost: review.node.totalCost,
                    solution: review.node.solution,
                    reviewNodeId: review.node.nodeId,
                    imagePath: review.node.imagePath,
                    solCategory: review.node.solCategory,
                    solSubCategory: review.node.solSubCategory,
                    insReportId: review.node.insReportId,
                    approve: review.node.approve,
                    categoryName: review.node.categoryName, //from input
                    subCategoryName: review.node.subCategoryName, //from input
                    keywords: review.node.keywords,
                    hourRate: review.node.hourRate,
                    laborHour: review.node.laborHour,
                    labourCost: review.node.labourCost,
                    materialCost: review.node.materialCost,
                    costOption: review.node.costOption,
                    ni: review.node.ni,
                    cpi: review.node.cpi,
                    cpf: review.node.cpf,
                    tf: review.node.tf,
                    keyPrimCategory: review.node.keyPrimCategory,
                    key1: review.node.key1,
                    keyPhrase: review.node.keyPhrase,
                    key2: review.node.key2,
                    key3: review.node.key3,
                    key4: review.node.key4,
                    approveDatetime: review.node.approveDatetime,
                  };

                  this.allReviewReports.push(assignedObject);
                  this.allReviewReports1.push(assignedObject);
                  //calculating total cost
                  this.forTotalCost =
                    Number(this.forTotalCost) + Number(review.node.totalCost);

                  if (
                    response.data.allReportReviewDetails.edges.length ==
                    this.allReviewReports.length
                  ) {
                    this.bottomResultSpinner = false;
                  }
                }
              );
            } else {
              this.enableApproved = true; // Enabled approved if anything yet to be  approved
              this.bottomResultSpinner = false;
            }

            this.dataSource = new MatTableDataSource(this.allReviewReports);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.dataSourceSort;
          },
          () => {
            this.bottomResultSpinner = false;
            this.bodySpinner = false;
          }
        )
    );
  }

  isApproveToClientButton(): boolean {
    return this.approveDynamic &&
      this.approveDynamic.key === 'approve_to_client';
  }

  async initailStagesForApprove(stage: ApproveDynamic) {

    // ONLY check permission for "Approve to client" button
    if (this.isApproveToClientButton()) {
      if (!this.checkPermissionWithMessage('approve', 'approve to client')) {
        return;
      }
    }

    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: false,
    });

    this.confirmDialogRef.componentInstance.confirmMessage =
      this.toastMsg.afterSubmitLevels;
    this.confirmDialogRef.componentInstance.confirmHead =
      this.toastMsg.submitLevels;
    this.confirmDialogRef.componentInstance.confirmOkText =
      this.toastMsg.alterSolutionOk;
    this.confirmDialogRef.componentInstance.confirmCancelText =
      this.toastMsg.alterSolutionCancel;

    this.confirmDialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        // Use enhanced status resolution
        let statusId = this.getStatusIdByName(stage.nextStatus);

        if (!statusId) {
          this.toastComponent.showToast('Error: Unable to find status "' + stage.nextStatus + '". Please contact support.');
          return;
        }

        if (stage.key === "approve_to_client") {
          await this.approveSolution(statusId);
        } else {
          this.changeStatus(statusId);
        }
      }
    });
  }
  canShowApproveButton(): boolean {
    if (this.isApproveToClientButton()) {
      return this.canPerformAction('approve');
    }
    return true;
  }

  // Update the button disabled state
  isApproveButtonDisabled(): boolean {
    if (this.isApproveToClientButton()) {
      return !this.canPerformAction('approve');
    }
    return false;
  }

  getApproveButtonTooltip(): string {
    if (this.isApproveToClientButton() && !this.canPerformAction('approve')) {
      return `Only Account Owner can approve to client. Your role: ${this.userRole}`;
    }
    return '';
  }

  // Safe method to get approveDynamic value
  getApproveDynamicValue(): string {
    return this.approveDynamic && this.approveDynamic.value ? this.approveDynamic.value : '';
  }


  changeStatus(statusId, type?) {
    if (!statusId) {
      this.toastComponent.showToast('Error: Invalid status. Please try again.');
      return;
    }

    if (!this.currentOrderId) {
      this.toastComponent.showToast('Error: Order ID is missing. Please refresh and try again.');
      return;
    }

    if (!this.userId) {
      this.toastComponent.showToast('Error: User ID is missing. Please login again.');
      return;
    }

    let oldData = {
      "statusId": this.selectedOrder.statusId,
      "orderId": this.currentOrderId,
      "userId": this.userId
    }

    let newData = {
      "statusId": statusId,
      "orderId": this.currentOrderId,
      "userId": this.userId
    }

    this.allordersService.createStatus(this.currentOrderId, statusId, this.userId).then((response: any) => {
      if (type != 'fromApprove') {
        this.auditHistoryFunCall("Success", "submit_se_status", oldData, newData)
      }

      this.toastComponent.showToast(this.toastMsg.statusChangeSuccess);

      // Routing to order or refresh - ALL roles get same treatment
      this.refresh();

    }).catch(err => {
      if (type != 'fromApprove') {
        this.auditHistoryFunCall("Failed", "submit_se_status", oldData, newData)
      }
      this.toastComponent.showToast(this.toastMsg.statusChange);
      console.log(err);
    });
  }


  async approveSolution(statusId) {

    if (!this.checkPermissionWithMessage('approve', 'approve solutions')) {
      return;
    }

    // Check solution email exist
    // this.solEmail
    //   ? (this.solutionEstimateEmails = [this.solEmail, this.orderEmail])
    //   : this.solutionEstimateEmails.push(this.orderEmail);

    this.solutionEstimateEmails = this.solEmail.split(",");

    this.emailConfirmRef = this.dialog.open(ConfirmDialogComponent, {
      width: "400px",
      disableClose: false,
    });

    this.emailConfirmRef.componentInstance.confirmMessage =
      this.toastMsg.editEmailConfirm;
    this.emailConfirmRef.componentInstance.confirmHead =
      this.toastMsg.editEmailHead;
    this.emailConfirmRef.componentInstance.confirmOkText =
      this.toastMsg.editEmailOk;
    this.emailConfirmRef.componentInstance.confirmCancelText =
      this.toastMsg.editEmailCancel;
    this.emailConfirmRef.componentInstance.emails = _.uniq(
      this.solutionEstimateEmails
    );

    // Alter email popup opens
    await this.emailConfirmRef.afterClosed().subscribe((result) => {
      // if confirm
      if (result) {
        const dialogRef = this.dialog.open(EmailPopupComponent, {
          width: "400px",
          data: {
            currentOrderId: this.currentOrderId,
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (!result) {
            return;
          }

          const actionType: string = result[0];

          switch (actionType) {
            /**
             * Save
             */
            case "save":
              const alterEmail: string = result[1];
              this.toastComponent.showToast(toastMsg.emailAddSuccess);
              this.storeApprove(alterEmail); //pass alter email
              this.changeStatus(statusId, 'fromApprove');
              break;
            /**
             * Failed
             */
            case "failed":
              this.toastComponent.showToast(toastMsg.emailAddFailed);
              break;

            case "cancel":
              this.storeApprove(''); //pass alter email
              this.changeStatus(statusId, 'fromApprove');
              break;
          }
        });
      } else if (result == false) {
        // if no
        this.storeApprove('');
        this.changeStatus(statusId, 'fromApprove');
      }
    });

    //call function to sret Role Id of user id
    this.solutionFormService
      .CREATE_SOLUTION_ESTIMATE_USER(this.currentOrderId, this.insReportId)
      .then((res: any) => {
        if (res && res.data && res.data.createSolutionestimateuser) {
          console.log("result done");
        } else {
          this.toastComponent.showToast(toastMsg.warningForCategory);
        }
      })
      .catch(() => {
        this.toastComponent.showToast(toastMsg.warningForCategory);
      });
  }

  // To Approve values
  storeApprove(alterEmail) {
    this.bottomResultSpinner = true;

    _.each(this.allReviewReports, (report, key) => {
      // Change approve status
      this.reportReviewQueryService
        .UPDATE_APPROVE_REPORT_REVIEW(report.reviewNodeId, "yes")
        .subscribe(
          () => {
          },
          (err) => {
          }
        );

      if (key + 1 == this.allReviewReports.length) {
        this.auditHistoryFunCall("Success", 'approve');
        this.toastComponent.showToast(this.toastMsg.approvedSuccess);
        this.bottomResultSpinner = false;
        this.enableApproved = false;
        alterEmail
          ? this.solutionEstimateEmails.push(alterEmail)
          : (this.solutionEstimateEmails = this.solutionEstimateEmails);

        /** Send report id notification to client first */
        this.formService
          .sentReportId(
            this.insReportId,
            this.selectedOrder,
            this.subjectPropertyAddress,
            _.uniq(this.solutionEstimateEmails), // Client emails only
            this.roleId,
            this.userId,
            this.currentOrderId
          )
          .then((data) => {
            this.toastComponent.showToast(this.toastMsg.mailNotifyAboutIdSuccess);
            this.sendInternalNotification();
          })
          .catch((error) => {
            console.error('Client email sending error:', error);
            this.toastComponent.showToast(this.toastMsg.mailNotifyAboutIdFailed);
          });

        // Rest of your SMS code remains the same
        let userName = this.selectedOrder && this.selectedOrder.billing && this.selectedOrder.billing.first_name ?
          this.selectedOrder.billing.first_name : (this.selectedOrder && this.selectedOrder.billing && this.selectedOrder.billing.last_name ?
            this.selectedOrder.billing.last_name : "");
        let formattedPhone = this.selectedOrder && this.selectedOrder.billing && this.selectedOrder.billing.phone ? this.selectedOrder.billing.phone : "";

        this.formService.sendSMS(userName, formattedPhone, this.roleId, this.userId, this.currentOrderId).then((smsRes: any) => {
          if (smsRes && smsRes.status && (parseInt(smsRes.status) == 200)) {
            this.toastComponent.showToast(
              this.toastMsg.smsNotifyAboutIdSuccess
            );
          }
          else {
            this.toastComponent.showToast(
              this.toastMsg.smsNotifyAboutIdFailed
            );
          }
        }, () => {
          this.toastComponent.showToast(
            this.toastMsg.smsNotifyAboutIdFailed
          );
        })
      }
    });
  }

  sendInternalNotification() {
    const internalEmail = ["sky@spekwo.com"];

    this.formService
      .sentReportId(
        this.insReportId,
        this.selectedOrder,
        this.subjectPropertyAddress,
        internalEmail,
        this.roleId,
        this.userId,
        this.currentOrderId
      )
      .then((data) => {
        console.log('Internal notification sent successfully to sky@spekwo.com');
      })
      .catch((error) => {
        console.error('Internal email sending error:', error);
      });
  }
  resendQuoteToClient() {
    if (!this.canPerformAction('approve')) {
      this.toastComponent.showToast('Only Account Owner and Executive can resend quotes to client. Your current role: ' + this.userRole);
      return;
    }

    var self = this;
    if (this.allReviewReports.length === 0) {
      this.toastComponent.showToast(this.toastMsg.noApprovedSolutionsToResend || 'No approved solutions to resend');
      return;
    }

    var hasApprovedSolutions = this.allReviewReports.some(function (report) {
      return report.approve === 'yes';
    });
    if (!hasApprovedSolutions) {
      this.toastComponent.showToast(this.toastMsg.solutionsNotApproved || 'Solutions must be approved before resending');
      return;
    }

    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: false,
    });

    this.confirmDialogRef.componentInstance.confirmMessage =
      this.toastMsg.resendQuoteConfirm || 'Are you sure you want to resend the quote to the client?';
    this.confirmDialogRef.componentInstance.confirmHead =
      this.toastMsg.resendQuoteHead || 'Resend Quote';
    this.confirmDialogRef.componentInstance.confirmOkText =
      this.toastMsg.resendQuoteOk || 'Resend';
    this.confirmDialogRef.componentInstance.confirmCancelText =
      this.toastMsg.resendQuoteCancel || 'Cancel';

    this.confirmDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.processResendQuote();
      }
    });
  }


  private processResendQuote() {
    // Prepare email list (same logic as in approveSolution)
    this.solutionEstimateEmails = this.solEmail.split(",");

    this.emailConfirmRef = this.dialog.open(ConfirmDialogComponent, {
      width: "400px",
      disableClose: false,
    });

    this.emailConfirmRef.componentInstance.confirmMessage =
      this.toastMsg.editEmailConfirm;
    this.emailConfirmRef.componentInstance.confirmHead =
      this.toastMsg.editEmailHead;
    this.emailConfirmRef.componentInstance.confirmOkText =
      this.toastMsg.editEmailOk;
    this.emailConfirmRef.componentInstance.confirmCancelText =
      this.toastMsg.editEmailCancel;
    this.emailConfirmRef.componentInstance.emails = _.uniq(
      this.solutionEstimateEmails
    );

    this.emailConfirmRef.afterClosed().subscribe((result) => {
      if (result) {
        // Open email popup for additional email if needed
        const dialogRef = this.dialog.open(EmailPopupComponent, {
          width: "400px",
          data: {
            currentOrderId: this.currentOrderId,
          },
        });

        dialogRef.afterClosed().subscribe((emailResult) => {
          if (!emailResult) {
            return;
          }

          const actionType: string = emailResult[0];
          let alterEmail = '';

          switch (actionType) {
            case "save":
              alterEmail = emailResult[1];
              this.toastComponent.showToast(toastMsg.emailAddSuccess);
              break;
            case "failed":
              this.toastComponent.showToast(toastMsg.emailAddFailed);
              return;
            case "cancel":
              alterEmail = '';
              break;
          }

          this.sendResendEmail(alterEmail);
        });
      } else if (result === false) {
        // Send without additional email
        this.sendResendEmail('');
      }
    });
  }

  private sendResendEmail(alterEmail: string) {
    this.bottomResultSpinner = true;

    // Prepare final email list
    const finalEmailList = alterEmail
      ? _.uniq([...this.solutionEstimateEmails, alterEmail])
      : _.uniq(this.solutionEstimateEmails);

    // Send email to client
    this.formService
      .sentReportId(
        this.insReportId,
        this.selectedOrder,
        this.subjectPropertyAddress,
        finalEmailList,
        this.roleId,
        this.userId,
        this.currentOrderId
      )
      .then((data) => {
        this.bottomResultSpinner = false;
        this.toastComponent.showToast(this.toastMsg.quoteResendSuccess || 'Quote resent successfully');

        // Send internal notification
        this.sendInternalNotification();

        // Optionally send SMS
        this.sendResendSMS();
      })
      .catch((error) => {
        this.bottomResultSpinner = false;
        console.error('Resend email error:', error);
        this.toastComponent.showToast(this.toastMsg.quoteResendFailed || 'Failed to resend quote');
      });
  }

  private sendResendSMS() {
    const userName = this.selectedOrder && this.selectedOrder.billing && this.selectedOrder.billing.first_name ?
      this.selectedOrder.billing.first_name :
      (this.selectedOrder && this.selectedOrder.billing && this.selectedOrder.billing.last_name ?
        this.selectedOrder.billing.last_name : "");
    const formattedPhone = this.selectedOrder && this.selectedOrder.billing && this.selectedOrder.billing.phone ?
      this.selectedOrder.billing.phone : "";

    if (formattedPhone) {
      this.formService.sendSMS(userName, formattedPhone, this.roleId, this.userId, this.currentOrderId)
        .then((smsRes: any) => {
          if (smsRes && smsRes.status && parseInt(smsRes.status) === 200) {
            this.toastComponent.showToast(this.toastMsg.smsResendSuccess || 'SMS notification sent');
          } else {
            this.toastComponent.showToast(this.toastMsg.smsResendFailed || 'SMS notification failed');
          }
        })
        .catch(() => {
          this.toastComponent.showToast(this.toastMsg.smsResendFailed || 'SMS notification failed');
        });
    }
  }

  //Print pdf
  printValue(quoteRequestedDate, quoteDeliveredDate) {
    this.bodySpinner = true;
    this.dialogRef = this.dialog.open(printDialogComponent, {
      autoFocus: false,
      panelClass: "contact-form-dialog",
      width: 'calc(100% - 0%)',
      height: 'calc(100% - 0%)',
      data: {
        arrayData: this.allReviewReports,
        action: "print",
        orderType: "spekwo",
        quoteRequestedDate: quoteRequestedDate,
        quoteDeliveredDate: quoteDeliveredDate,
      },
    });

    this.dialogRef.afterClosed().subscribe((response) => {
      setTimeout(() => {
        this.bodySpinner = false;
      });
    });
  }

  goback() {
    this.router.navigate(['/apps/e-commerce/orders'])
    // this.location.back();
  }

  //Check empty object or not
  isObjectEmpty(obj) {
    return _.isEmpty(obj);
  }

  getAddressValue(address, city, state, zip) {
    if ((zip && address && address.toString().includes(zip.toString())) ||
      (city && address && address.toString().includes(city.toString())) ||
      (state && address && address.toString().includes(state.toString()))) {
      return (address ? address.toString() : "");
    }
    else {
      return (address ? address.toString() : "") + (city ? (", " + city.toString()) : "") + (state ? (", " + state.toString()) : "") + (zip ? (", " + zip.toString()) : "");
    }
  }


  alterSolution() {
    // Check permissions first
    if (!this.checkPermissionWithMessage('alter', 'alter solutions')) {
      return;
    }

    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: false,
    });

    this.confirmDialogRef.componentInstance.confirmMessage =
      this.toastMsg.alterSolution;
    this.confirmDialogRef.componentInstance.confirmHead =
      this.toastMsg.alterSolutionHead;
    this.confirmDialogRef.componentInstance.confirmOkText =
      this.toastMsg.alterSolutionOk;
    this.confirmDialogRef.componentInstance.confirmCancelText =
      this.toastMsg.alterSolutionCancel;

    this.confirmDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.bottomResultSpinner = true;

        _.each(this.allReviewReports, (report, key) => {
          this._subscriptions.push(
            this.reportReviewQueryService
              .UPDATE_APPROVE_REPORT_REVIEW(report.reviewNodeId, "no")
              .subscribe(
                (response: any) => {
                },
                () => { }
              )
          );
          if (key + 1 == this.allReviewReports.length) {
            this.bottomResultSpinner = false;
            this.enableApproved = true;
            this.auditHistoryFunCall("Success", 'alter');
          }
        });
      }
    });
  }
  tableRefresh(event) {
    if (event.flag) {
      this.getAllStoredReports();
    }
  }

  openSupportinfo(data) {
    data['itemsNumber'] = [this.itemsNumber];
    if (this.itemsAndDescriptions.length > 0) {
      data['itemsAndDescriptions'] = JSON.parse(this.itemsAndDescriptions);
    }
    this.dialog.open(PreviewSupportingInfoComponent, {
      panelClass: "supporting-info-dialog",
      data: data,
      width: "100%",
      // height: "85%",
    });
  }

  viewLog() {
    this.dialogRef = this.dialog.open(ViewLogsDialogComponent, {
      width: '100%',
      panelClass: 'log-info-dialog',
      data: {
        orderId: Number(this.currentOrderId)
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        console.log("response", response)
      })
  }

  refresh() {
    this.viewBoolean = this.router.url.includes("view");
    // get current order from params
    this.route.params.subscribe((params) => {
      this.currentOrderId = Number.parseInt(params.id);
    });

    this.allCategories = this.combineCategories;

    this.userRole = window.localStorage.getItem("role");
    this.userId = window.localStorage.getItem('userUID');
    this.roleId = window.localStorage.getItem('roleId');

    // Update permissions when refreshing
    this.setUserPermissions();

    this.getCurrentOrderByOrderId();

    this.commonOrdersService.listOfStatus.subscribe((statusRes) => {
      this.allStatus = statusRes.length > 0 ? statusRes : [];
    });
    // this.getCurrentOrderByOrderId();

    this.forTotalCost = 0; // total cost after saving
    this.beforeTotalCost = 0; // total cost before saving
    this.cost = [];

    this.pageNumber = 1; // initially set to 1st page
    this.itemsPerPage = this.initalLoad; // initally set to initial value
    this.dragIndex = 0; //initially set to 0

    this.itemsPerPageForReports = this.initalLoadForReports;
    this.pageNumberForReports = 1;
    this.dragIndexForReports = 0;

    //2.Check this report submitted by clieent
    this.checkOrderStatus();

    //3.all review Details from stored details
    this.getAllStoredReports();

    this._subscriptions.push(
      this.formService.currentOrderChanged.subscribe((order) => {
        this.orderDetailSpinner = true;
        if (order) {
          //1.get current order status
          this.getOrder(order);
        }
      })
    );
    this._subscriptions.push(
      this.formService.ocrDocumentChange.subscribe((res) => {
        if (!res.loading) {
          this.ocrDocumentUrl = res.data;
        }
      })
    );

    //get subjectProperty address.
    this._subscriptions.push(
      this.formService.buyerPropertyChanges.subscribe((data) => {
        this.subjectPropertyAddress = data;
      })
    );
    //get Inspection report  id.
    this._subscriptions.push(
      this.formService.insReportIdChange.subscribe((data) => {
        this.insReportId = data && data.insReportId;
      })
    );

    //Solution estiamtion email.
    this._subscriptions.push(
      this.formService.solutionEmailChanges.subscribe((data) => {
        this.solEmail = data ? data : "";
        // console.log('solutionEmailChanges', this.UTCsecondsPipe.transform());
      })
    );

    //Pdf file link for new order.
    this._subscriptions.push(
      this.formService.pdfLinkFromCheckout.subscribe((checkRes) => {
        if (!checkRes.loading) {
          // console.log('this.pdfFromCheckout', checkRes)
          var attachmentId = this.currentOrderId - 1;
          this.allordersService.getAttachmentdata1(
            attachmentId,
            this.currentOrderId,
            checkRes.data
          );
        }
      })
    );

    //Pdf final file link.
    this._subscriptions.push(
      this.allordersService.currentOrderPdfFinalLink.subscribe((res) => {
        if (!res.loading) {
          this.isOrderHasAttachment = res.data.isOrderHasAttachment;
          this.currentOrderAttachLink = res.data.currentOrderAttachLink;
        } else {
          this.isOrderHasAttachment = false;
          this.currentOrderAttachLink = "";
        }
      })
    );
  }

  auditHistoryFunCall(status?, flag?, oldData?, newData?) {

    if (flag == 'approve') {

      let auditLogPayload = {
        roleId: this.roleId,
        userId: this.userId,
        orderId: Number(this.currentOrderId),
        newData: null,
        oldData: null,
        auditType: "approve_to_client",
        logsDesc: "Approved to client",
        platform: "Executive Dashboard",
        status: status
      };
      this.auditHistoryService.auditHistoryForCreateOrDeleteCall(auditLogPayload);
    }

    if (flag == 'alter') {

      let auditLogPayload = {
        roleId: this.roleId,
        userId: this.userId,
        orderId: Number(this.currentOrderId),
        newData: null,
        oldData: null,
        auditType: "approve_to_client_altered",
        logsDesc: "Approved to client altered ",
        platform: "Executive Dashboard",
        status: status
      };
      this.auditHistoryService.auditHistoryForCreateOrDeleteCall(auditLogPayload);
    }

    if (flag == 'submit_se_status') {

      let auditLogPayload = {
        roleId: this.roleId,
        userId: this.userId,
        orderId: Number(this.currentOrderId),
        newData: newData,
        oldData: oldData,
        auditType: "submit_se_status",
        logsDesc: "Solution estimate submitted",
        platform: "Executive Dashboard",
        status: status
      };

      this.auditHistoryService.auditHistoryForStatusChange(auditLogPayload);

    }

  }

  addFieldValue(type) {
    this.selectedViewType = type;
    setTimeout(() => {
      this.selectedViewType = '';
    }, 100);
  }

  setFullSpekwoDataFormat(tempArray) {
    let localArray = tempArray;

    if (localArray && localArray.length > 0) {
      for (let i = 0; i < localArray.length; i++) {
        let rowData = localArray[i];

        if (localArray[i].id != null || localArray[i].description != "" || localArray[i].image != "") {

          let obj = {
            id: rowData && rowData['id'] ? rowData['id'] : null,
            description: rowData && rowData['description'] ? rowData['description'] : '',
            image: rowData && rowData['image'] ? rowData['image'] : '',
          }

          this.finalFullSpekwoRes.push(obj);
        }
      }
    }
    else {
      this.finalFullSpekwoRes = [];
    }
  }

  convertUtcToEst(timeStamp) {
    if (timeStamp) {
      const gmtTimestamp = timeStamp;

      const gmtDate = new Date(gmtTimestamp);

      const estFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short',
      });

      // Format the GMT date to EST
      let estDateTime = estFormatter.format(gmtDate);
      estDateTime = estDateTime.replace(/\s\w+$/, '');
      return estDateTime;
    }

    return "";
  }

  getStatusIdByName(statusName: string): number | null {


    // First try to find in allStatus array (preferred method)
    if (this.allStatus && this.allStatus.length > 0) {
      let filterStatus = this.allStatus.filter((status) => {
        return status.statusName === statusName;
      });

      if (filterStatus.length > 0 && filterStatus[0].statusId) {
        return filterStatus[0].statusId;
      }
    }

    // Fallback to hardcoded mapping
    if (STATUS_ID_MAPPING[statusName]) {
      return STATUS_ID_MAPPING[statusName];
    }

    return null;
  }


}

export interface ReviewData {
  reviewId: number;
  id: number;
  name: string;
  description: string;
  totalCost: number;
}

export interface OrderStatus {
  statusId: number;
  statusName: string;
  displayStatus: string;
}

interface ApproveDynamic {
  value?: string;
  key?: string;
  nextStatus?: string;
  respectiveStatus?: string;
} 


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/spekwo-type/spekwo.component.ts